/**
 * Pads a number or string with leading characters to reach specified width
 * @param value - The value to pad (number or string)
 * @param width - The desired total length of the resulting string
 * @param padChar - The character to use for padding (defaults to '0')
 * @returns The padded string
 * @example
 * leftPad(5, 3)     // returns "005"
 * leftPad(5, 3, '*') // returns "**5"
 * leftPad(123, 2)   // returns "123"
 */
export const leftPad = function (value: number | string, width: number, padChar: string = "0"): string {
	// Input validation
	if (width < 0) {
		throw new Error("Width must be a non-negative number");
	}

	if (padChar.length !== 1) {
		throw new Error("Pad character must be a single character");
	}

	// Convert value to string
	const str = String(value);

	// If the string is already longer than or equal to the width, return as is
	if (str.length >= width) {
		return str;
	}

	// More efficient padding using repeat method
	return padChar.repeat(width - str.length) + str;
};
